/* eslint-disable operator-linebreak */
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import _isEmpty from 'lodash/isEmpty';

const HeaderViewPropTypes = {
  title: PropTypes.string.isRequired, // Title for the application
  body: PropTypes.string.isRequired, // Description of the application
  editing: PropTypes.bool.isRequired, // If the route is being edited
  prevState: PropTypes.shape({}).isRequired, // The state of the application before a user edits their route
  directionsError: PropTypes.bool.isRequired, // True if an error occurred
  toggle: PropTypes.bool.isRequired, // State of the Vehicle selector
  isMobile: PropTypes.bool.isRequired, // True when the app is loaded on a handheld sized device
};

const HeaderViewDefaultProps = {};

// eslint-disable-next-line arrow-parens
const HeaderView = props => {
  const {
    title,
    body,
    editing,
    prevState,
    directionsError,
    toggle,
    isMobile,
  } = props;

  return (
    <div
      className={classNames('header', {
        collapse:
          !editing ||
          !_isEmpty(prevState) ||
          directionsError ||
          (toggle && !isMobile),
      })}
    >
      <h1 dangerouslySetInnerHTML={{ __html: title }} />
      <div dangerouslySetInnerHTML={{ __html: body }} />
    </div>
  );
};

HeaderView.propTypes = HeaderViewPropTypes;

HeaderView.defaultProps = HeaderViewDefaultProps;

export default HeaderView;
